export default Object.freeze({
    STATUS_AWAITING_PAYMENT: 'A',
    STATUS_PAID: 'P',
    STATUS_CANCELED: 'C',
    STATUS_INVOICED: 'F',
    STATUS_AWAITING_RELEASE: 'L',
    STATUS_OVERDUE: 'I',
    STATUS_EXTENDED_RECURRENCE: 'E',
    STATUS_RENEGOTIATED: 'R',
    STATUS_FORGIVEN: 'S',
    STATUS_RENEGOTIATION_CANCELED: 'X',
    STATUS_REFUNDED: 'D',
    STATUS_REFUNDED_ONLY_SK: 'K',
});